import {
  defineStore,
  generateInitialState,
  resetState,
  type ToSetupState,
} from "#src/stores/state-wrapper.ts";
import { STEP } from "#src/constants/step.ts";

import { useStepSignatureWaitingStore } from "#src/stores/step-signature-waiting.ts";
import { useStepCompletedStore } from "#src/stores/step-completed.ts";
import { type Pinia, type StoreGeneric } from "pinia";
import { computed, type Ref, ref } from "vue";
import { type BaseStepStore } from "#src/types/StepStore.ts";

interface SignatureState {
  isFullscreen: boolean;
  signingByEmail: boolean | null;
}

interface SignatureStep extends BaseStepStore, ToSetupState<SignatureState> {}

function initialState(): SignatureState {
  return {
    isFullscreen: false,
    signingByEmail: null,
  };
}

function initializeSignatureStep(pinia: Pinia): SignatureStep {
  const state = generateInitialState<SignatureState>(initialState());

  function $reset() {
    resetState(state, initialState());
  }

  const step = computed(() => STEP.SIGNATURE);
  const previous = computed(() => {
    const signatureWaiting = useStepSignatureWaitingStore(pinia);
    return signatureWaiting.step;
  });
  const next = computed(() => {
    const completed = useStepCompletedStore(pinia);
    return completed.step;
  });
  const controlsNext = computed(() => true);
  const hidesShare = computed(() => true);
  const hidesFooter = computed(() => true);

  return {
    $reset,
    ...state,
    step,
    previous,
    next,
    controlsNext,
    hidesShare,
    hidesFooter,
  };
}

export function useStepSignatureStore(pinia: Pinia, hot?: StoreGeneric) {
  return defineStore<string, SignatureStep>("step-signature", () => {
    return initializeSignatureStep(pinia);
  })(pinia, hot);
}
